import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-gap: ${props => props.theme.gridGap.default};
  margin: 0 0 30px 0;

  &:empty {
    margin: 0;
  }

  ${props =>
    props.horizontal &&
    css`
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      gap: 0;
      & > div {
        width: auto;
      }
    `}

  ${Media.md`
    grid-gap: ${props => props.theme.gridGap.md};
    margin: 0 0 30px 0;
  `}
`;

export const Item = styled.div`
  display: block;
  width: 100%;
`;
